import { useCallback, useMemo } from 'react';

import { getTrait, mapApiTraitDetailToUi } from '../../../services/traits.js';
import { useItemDetail } from './useItemDetail.js';

/**
 * One trait's detail, for the slide-out (CT-5715). The race guard, the 404 /
 * 403 outcomes and the quiet `refresh` are `useItemDetail`'s.
 */
export function useTrait({ entityType, entityId, traitId } = {}) {
  // The service is read at call time, not captured, so a test can spy on it.
  const load = useCallback(() => getTrait({ entityType, entityId, traitId }), [entityType, entityId, traitId]);
  const { item, loading, error, notFound, accessDenied, refetch, refresh } = useItemDetail({
    id: traitId,
    load,
    map: mapApiTraitDetailToUi,
    errorMessage: 'Failed to load the trait',
  });

  return useMemo(
    () => ({ trait: item, loading, error, notFound, accessDenied, refetch, refresh }),
    [item, loading, error, notFound, accessDenied, refetch, refresh],
  );
}

export default useTrait;
